const getters = {
  token: (state) => state.user.token,
  name: (state) => state.user.name,
  creditCode: (state) => state.user.creditCode,
  roles: (state) => state.user.roles,
  permissions: (state) => state.user.permissions,
  permission_routes: (state) => state.permission.routes,
  userLevel: (state) => state.user.userLevel,
  userLevelName: (state) => state.user.userLevelName,
  customerCode: (state) => state.user.customerCode,
  customerName: (state) => state.user.customerName,
  printId: (state) => state.print.printId,
  printStatus: (state) => state.print.printStatus,
  partner: (state) => state.user.partner,
  isExpire: (state) => state.user.isExpire,
  diffDate: (state) => state.user.diffDate,
  userMenu: (state) => state.user.userMenu,
  isBuy: (state) => state.user.isBuy,
  phone: (state) => state.user.phone,
  versionName: (state) => state.user.versionName,
  versionId: (state) => state.user.versionId,
  newBuyDate: (state) => state.user.newBuyDate,
  expiredTime: (state) => state.user.expiredTime,
};
export default getters;
